 
// import React, { useState } from "react";
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaBriefcase,
//   FaBuilding,
//   FaFileUpload,
//   FaPlus,
// } from "react-icons/fa";

// const ApplicationForm = () => {
//   const [selectedSkills, setSelectedSkills] = useState([]);
//   const [customSkill, setCustomSkill] = useState("");
//   const suggestedSkills = ["Java", "C", "React", "SQL", "Python", "Node.js"];

//   const handleSkillClick = (skill) => {
//     if (!selectedSkills.includes(skill)) {
//       setSelectedSkills([...selectedSkills, skill]);
//     }
//   };

//   const handleRemoveSkill = (skill) => {
//     setSelectedSkills(selectedSkills.filter((s) => s !== skill));
//   };

//   const handleAddCustomSkill = () => {
//     if (customSkill.trim() !== "" && !selectedSkills.includes(customSkill)) {
//       setSelectedSkills([...selectedSkills, customSkill]);
//       setCustomSkill("");
//     }
//   };

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.container}>
//         {/* Left Side Image */}
//         <div style={styles.imageSection}>
//           <img
//             src="/image/form.png"
//             alt="Application Banner"
//             style={styles.image}
//           />
//         </div>

//         {/* Right Side Form */}
//         <div style={styles.formSection}>
//           {/* Header */}
//           <div style={styles.header}>
//             {/* <img src="/image/pngeis.png" alt="Company Logo" style={styles.logo} /> */}
//             <h1 style={styles.title}>Apply Now</h1>
//           </div>

//           <form style={styles.form}>
//             {/* Full Name */}
//             <div style={styles.inputWrapper}>
//               <FaUser style={styles.icon} />
//               <input type="text" placeholder="Full Name" style={styles.input} required />
//             </div>

//             {/* Email */}
//             <div style={styles.inputWrapper}>
//               <FaEnvelope style={styles.icon} />
//               <input type="email" placeholder="Email" style={styles.input} required />
//             </div>

//             {/* Phone */}
//             <div style={styles.inputWrapper}>
//               <FaPhone style={styles.icon} />
//               <input type="tel" placeholder="Phone Number" style={styles.input} required />
//             </div>

//             {/* Experience */}
//             <div style={styles.inputWrapper}>
//               <FaBriefcase style={styles.icon} />
//               <select style={styles.input} required>
//                 <option value="">Select Experience</option>
//                 <option value="0-1">0-1 years</option>
//                 <option value="1-3">1-3 years</option>
//                 <option value="3-5">3-5 years</option>
//                 <option value="5+">5+ years</option>
//               </select>
//             </div>

//             {/* Job Role */}
//             <div style={styles.inputWrapper}>
//               <FaBuilding style={styles.icon} />
//               <select style={styles.input} required>
//                 <option value="">Select Job Role</option>
//                 <option value="developer">Developer</option>
//                 <option value="it-admin">IT Admin</option>
//                 <option value="hr">HR</option>
//                 <option value="finance">Finance</option>
//                 <option value="marketing">Marketing</option>
//               </select>
//             </div>

//             {/* Skills */}
//             <div style={styles.skillsSection}>
//               <label style={styles.label}>Skills:</label>
//               <div style={styles.suggestedSkills}>
//                 {suggestedSkills.map((skill, index) => (
//                   <span
//                     key={index}
//                     style={styles.skillChip}
//                     onClick={() => handleSkillClick(skill)}
//                   >
//                     {skill}
//                   </span>
//                 ))}
//               </div>

//               {/* Custom Skill Input */}
//               <div style={styles.customSkillWrapper}>
//                 <input
//                   type="text"
//                   placeholder="Add custom skill"
//                   value={customSkill}
//                   onChange={(e) => setCustomSkill(e.target.value)}
//                   style={styles.customSkillInput}
//                 />
//                 <button
//                   type="button"
//                   onClick={handleAddCustomSkill}
//                   style={styles.addSkillBtn}
//                 >
//                   <FaPlus />
//                 </button>
//               </div>

//               <div style={styles.selectedSkills}>
//                 {selectedSkills.map((skill, index) => (
//                   <span key={index} style={styles.selectedChip}>
//                     {skill}{" "}
//                     <button
//                       type="button"
//                       style={styles.removeBtn}
//                       onClick={() => handleRemoveSkill(skill)}
//                     >
//                       ×
//                     </button>
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* Resume Upload */}
//             <div style={styles.inputWrapper}>
//               <FaFileUpload style={styles.icon} />
//               <input type="file" style={styles.input} accept=".pdf,.doc,.docx" required />
//             </div>

//             {/* Submit */}
//             <button type="submit" style={styles.submitBtn}>
//               Submit Application
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Styles
// const styles = {
//   wrapper: {
//     width: "100%",
//     backgroundColor: "#025261",
//     display: "flex",
//     justifyContent: "center",
//     padding: "20px", // reduced padding (less height)
//   },
//   container: {
//     display: "flex",
//     width: "100%",
//     maxWidth: "1000px", // slightly smaller width
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
//     overflow: "hidden",
//     flexWrap: "wrap",
//     minHeight: "550px", // reduced height
//   },
//   imageSection: {
//     flex: 0.8, // reduced width
//     minWidth: "250px",
//     backgroundColor: "white",
//   },
//   image: {
//     width: "100%",
//     height: "100%",
//     objectFit: "contain", // smaller & clean image
//   },
//   formSection: {
//     flex: 1.2,
//     padding: "25px",
//     minWidth: "300px",
//     backgroundColor: "#fff",
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     marginBottom: "15px",
//     position: "relative",
//   },
//   logo: {
//     height: "40px",
//     position: "absolute",
//     left: "0",
//   },
//   title: {
//     flex: 1,
//     textAlign: "center",
//     fontSize: "24px",
//     fontWeight: "bold",
//     color: "#007bff",
//     margin: 0,
//     letterSpacing:"0px",
//   },
//   form: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "15px",
//   },
//   inputWrapper: {
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//   },
//   icon: {
//     position: "absolute",
//     left: "12px",
//     color: "#007bff",
//     fontSize: "15px",
//   },
//   input: {
//     width: "100%",
//     padding: "10px 12px 10px 38px",
//     fontSize: "14px",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     outline: "none",
//   },
//   label: {
//     fontWeight: "bold",
//     marginBottom: "5px",
//     display: "block",
//   },
//   skillsSection: {
//     marginTop: "8px",
//   },
//   suggestedSkills: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "8px",
//     margin: "8px 0",
//   },
//   skillChip: {
//     padding: "5px 10px",
//     border: "1px solid #007bff",
//     borderRadius: "20px",
//     backgroundColor: "#f0f8ff",
//     color: "#007bff",
//     cursor: "pointer",
//     fontSize: "13px",
//   },
//   customSkillWrapper: {
//     display: "flex",
//     gap: "8px",
//     marginTop: "8px",
//   },
//   customSkillInput: {
//     flex: 1,
//     padding: "8px",
//     border: "1px solid #ccc",
//     borderRadius: "6px",
//     fontSize: "14px",
//   },
//   addSkillBtn: {
//     padding: "8px 12px",
//     border: "none",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     borderRadius: "6px",
//     cursor: "pointer",
//   },
//   selectedSkills: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "8px",
//     marginTop: "10px",
//   },
//   selectedChip: {
//     display: "inline-flex",
//     alignItems: "center",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     padding: "5px 10px",
//     borderRadius: "20px",
//     fontSize: "13px",
//   },
//   removeBtn: {
//     marginLeft: "6px",
//     border: "none",
//     background: "transparent",
//     color: "#fff",
//     fontSize: "14px",
//     cursor: "pointer",
//   },
//   submitBtn: {
//     padding: "12px",
//     fontSize: "15px",
//     fontWeight: "bold",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//   },
// };

// export default ApplicationForm;



import React, { useState } from "react";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaBriefcase,
  FaBuilding,
  FaFileUpload,
  FaPlus,
} from "react-icons/fa";

const ApplicationForm = () => {
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [customSkill, setCustomSkill] = useState("");
  const [hoveredField, setHoveredField] = useState(null);

  const suggestedSkills = ["Java", "C", "React", "SQL", "Python", "Node.js"];

  const handleSkillClick = (skill) => {
    if (!selectedSkills.includes(skill)) {
      setSelectedSkills([...selectedSkills, skill]);
    }
  };

  const handleRemoveSkill = (skill) => {
    setSelectedSkills(selectedSkills.filter((s) => s !== skill));
  };

  const handleAddCustomSkill = () => {
    if (customSkill.trim() !== "" && !selectedSkills.includes(customSkill)) {
      setSelectedSkills([...selectedSkills, customSkill]);
      setCustomSkill("");
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        {/* Left Side Image */}
        <div style={styles.imageSection}>
          <img
            src="/image/form.png"
            alt="Application Banner"
            style={styles.image}
          />
        </div>

        {/* Right Side Form */}
        <div style={styles.formSection}>
          {/* Header */}
          <div style={styles.header}>
            <h1 style={styles.title}>Apply Now</h1>
          </div>

          <form style={styles.form}>
            {/* Full Name */}
            <div style={styles.inputWrapper}>
              <FaUser style={styles.icon} />
              <input
                type="text"
                placeholder="Full Name"
                style={{
                  ...styles.input,
                  ...(hoveredField === "name" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("name")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("name")}
                onMouseLeave={() => setHoveredField(null)}
                required
              />
            </div>

            {/* Email */}
            <div style={styles.inputWrapper}>
              <FaEnvelope style={styles.icon} />
              <input
                type="email"
                placeholder="Email"
                style={{
                  ...styles.input,
                  ...(hoveredField === "email" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("email")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("email")}
                onMouseLeave={() => setHoveredField(null)}
                required
              />
            </div>

            {/* Phone */}
            <div style={styles.inputWrapper}>
              <FaPhone style={styles.icon} />
              <input
                type="tel"
                placeholder="Phone Number"
                style={{
                  ...styles.input,
                  ...(hoveredField === "phone" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("phone")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("phone")}
                onMouseLeave={() => setHoveredField(null)}
                required
              />
            </div>

            {/* Experience */}
            <div style={styles.inputWrapper}>
              <FaBriefcase style={styles.icon} />
              <select
                style={{
                  ...styles.input,
                  ...(hoveredField === "experience" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("experience")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("experience")}
                onMouseLeave={() => setHoveredField(null)}
                required
              >
                <option value="">Select Experience</option>
                <option value="0-1">0-1 years</option>
                <option value="1-3">1-3 years</option>
                <option value="3-5">3-5 years</option>
                <option value="5+">5+ years</option>
              </select>
            </div>

            {/* Job Role */}
            <div style={styles.inputWrapper}>
              <FaBuilding style={styles.icon} />
              <select
                style={{
                  ...styles.input,
                  ...(hoveredField === "jobrole" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("jobrole")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("jobrole")}
                onMouseLeave={() => setHoveredField(null)}
                required
              >
                <option value="">Select Job Role</option>
                <option value="developer">Developer</option>
                <option value="it-admin">IT Admin</option>
                <option value="hr">HR</option>
                <option value="finance">Finance</option>
                <option value="marketing">Marketing</option>
              </select>
            </div>

            {/* Skills */}
            <div style={styles.skillsSection}>
              <label style={styles.label}>Skills:</label>
              <div style={styles.suggestedSkills}>
                {suggestedSkills.map((skill, index) => (
                  <span
                    key={index}
                    style={styles.skillChip}
                    onClick={() => handleSkillClick(skill)}
                  >
                    {skill}
                  </span>
                ))}
              </div>

              {/* Custom Skill Input */}
              <div style={styles.customSkillWrapper}>
                <input
                  type="text"
                  placeholder="Add custom skill"
                  value={customSkill}
                  onChange={(e) => setCustomSkill(e.target.value)}
                  style={styles.customSkillInput}
                />
                <button
                  type="button"
                  onClick={handleAddCustomSkill}
                  style={styles.addSkillBtn}
                >
                  <FaPlus />
                </button>
              </div>

              <div style={styles.selectedSkills}>
                {selectedSkills.map((skill, index) => (
                  <span key={index} style={styles.selectedChip}>
                    {skill}{" "}
                    <button
                      type="button"
                      style={styles.removeBtn}
                      onClick={() => handleRemoveSkill(skill)}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            </div>

            {/* Resume Upload */}
            <div style={styles.inputWrapper}>
              <FaFileUpload style={styles.icon} />
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                style={{
                  ...styles.input,
                  ...(hoveredField === "resume" ? styles.inputHover : {}),
                }}
                onFocus={() => setHoveredField("resume")}
                onBlur={() => setHoveredField(null)}
                onMouseEnter={() => setHoveredField("resume")}
                onMouseLeave={() => setHoveredField(null)}
                required
              />
            </div>

            {/* Submit */}
            <button type="submit" style={styles.submitBtn}>
              Submit Application
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  wrapper: {
    width: "100%",
    backgroundColor: "#025261",
    display: "flex",
    justifyContent: "center",
    padding: "20px",
  },
  container: {
    display: "flex",
    width: "100%",
    maxWidth: "1000px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
    overflow: "hidden",
    flexWrap: "wrap",
    minHeight: "550px",
  },
  imageSection: {
    flex: 0.8,
    minWidth: "250px",
    backgroundColor: "white",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  formSection: {
    flex: 1.2,
    padding: "25px",
    minWidth: "300px",
    backgroundColor: "#fff",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    position: "relative",
  },
  title: {
    flex: 1,
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007bff",
    margin: 0,
    letterSpacing:"0px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  inputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    position: "absolute",
    left: "18px",
    color: "#007bff",
    fontSize: "15px",
  },
  input: {
    width: "100%",
    padding: "10px 12px 10px 38px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.3s ease",
  },
  inputHover: {
    borderColor: "#007bff",
    boxShadow: "0 0 6px rgba(0, 123, 255, 0.4)",
    backgroundColor: "#f9fcff",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "5px",
    display: "block",
  },
  skillsSection: {
    marginTop: "8px",
  },
  suggestedSkills: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    margin: "8px 0",
  },
  skillChip: {
    padding: "5px 10px",
    border: "1px solid #007bff",
    borderRadius: "20px",
    backgroundColor: "#f0f8ff",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "13px",
  },
  customSkillWrapper: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
  },
  customSkillInput: {
    flex: 1,
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
  },
  addSkillBtn: {
    padding: "8px 12px",
    border: "none",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "6px",
    cursor: "pointer",
  },
  selectedSkills: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "10px",
  },
  selectedChip: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "20px",
    fontSize: "13px",
  },
  removeBtn: {
    marginLeft: "6px",
    border: "none",
    background: "transparent",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
  },
  submitBtn: {
    padding: "12px",
    fontSize: "15px",
    fontWeight: "bold",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default ApplicationForm;
